import axios from "helpers/_axios";
import hasProperty from "lodash/has";
export const LOADING_METADATA = "LOADING_METADATA";
export const LOADING_ML_DOC_TYPES = "LOADING_ML_DOC_TYPES";
export const ERROR_METADATA = "ERROR_METADATA";
export const GET_ALL_MACHINE_LEARNING_TAGS = "GET_ALL_MACHINE_LEARNING_TAGS";
export const GET_ALL_METADATA = "GET_ALL_METADATA";
export const GET_METADATA = "GET_METADATA";
export const ADD_METADATA = "ADD_METADATA";
export const UPDATE_METADATA = "UPDATE_METADATA";
export const DELETE_METADATA = "DELETE_METADATA";
export const ADD_ML_TAG = "ADD_ML_TAG";

export const getMachineLearningInfo =
  ({ search = "", page = 1, items = 6 } = {}) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_ML_DOC_TYPES,
        payload: true
      });

      if (!page || page < 1) {
        page = 1;
      }
      if (!items || items < 1) {
        items = 6;
      }
      const result = await axios().get(
        `/metadata/ml/tags?search=${search}&page=${page}&items=${items}`
      );
      const tags = result.data.data.map(tag => ({ label: tag, value: tag }));
      dispatch({
        type: LOADING_ML_DOC_TYPES,
        payload: false
      });
      dispatch({
        type: ERROR_METADATA,
        payload: null
      });
      return dispatch({
        type: GET_ALL_MACHINE_LEARNING_TAGS,
        payload: tags
      });
    } catch (error) {
      dispatch({
        type: LOADING_ML_DOC_TYPES,
        payload: false
      });
      dispatch({
        type: GET_ALL_MACHINE_LEARNING_TAGS,
        payload: hasProperty(error, "response.status")
          ? error.response.status
          : 0
      });
      dispatch({
        type: ERROR_METADATA,
        payload: error
      });
    }
  };

export const addMachineLearningLabel =
  machineLearningLabel => async dispatch => {
    try {
      dispatch({
        type: LOADING_ML_DOC_TYPES,
        payload: true
      });
      const result = await axios().post(`/metadata/tags`, {
        tag: machineLearningLabel
      });

      dispatch({
        type: LOADING_ML_DOC_TYPES,
        payload: false
      });
      dispatch({
        type: ERROR_METADATA,
        payload: null
      });
      dispatch({
        type: ADD_ML_TAG,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_ML_DOC_TYPES,
        payload: false
      });

      dispatch({
        type: ERROR_METADATA,
        payload: error
      });
    }
  };

export const getAllMetadata =
  ({ title = "", page = 1 }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_METADATA,
        payload: true
      });
      const result = await axios().get(`/metadata?page=${page}&title=${title}`);
      dispatch({
        type: LOADING_METADATA,
        payload: false
      });
      dispatch({
        type: ERROR_METADATA,
        payload: null
      });
      return dispatch({
        type: GET_ALL_METADATA,
        payload: result.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_METADATA,
        payload: false
      });
      dispatch({
        type: GET_ALL_METADATA,
        payload: hasProperty(error, "response.status")
          ? error.response.status
          : 0
      });
      dispatch({
        type: ERROR_METADATA,
        payload: error
      });
    }
  };

export const getMetadata = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_METADATA,
      payload: true
    });
    const result = await axios().get(`/metadata/${id}`);
    dispatch({
      type: LOADING_METADATA,
      payload: false
    });
    dispatch({
      type: ERROR_METADATA,
      payload: null
    });
    dispatch({
      type: GET_METADATA,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_METADATA,
      payload: false
    });
    dispatch({
      type: GET_METADATA,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_METADATA,
      payload: error
    });
  }
};

export const addMetadata = data => async dispatch => {
  try {
    dispatch({
      type: LOADING_METADATA,
      payload: true
    });
    const result = await axios().post(`/metadata`, data);
    dispatch({
      type: LOADING_METADATA,
      payload: false
    });
    dispatch({
      type: ERROR_METADATA,
      payload: null
    });
    dispatch({
      type: ADD_METADATA,
      payload: result.data.data
    });
  } catch (error) {
    dispatch({
      type: LOADING_METADATA,
      payload: false
    });
    dispatch({
      type: ERROR_METADATA,
      payload: error
    });
  }
};

export const updateMetadata =
  ({ id, data }) =>
  async dispatch => {
    try {
      dispatch({
        type: LOADING_METADATA,
        payload: true
      });
      const result = await axios().put(`/metadata/${id}`, data);
      dispatch({
        type: LOADING_METADATA,
        payload: false
      });
      dispatch({
        type: ERROR_METADATA,
        payload: null
      });
      dispatch({
        type: UPDATE_METADATA,
        payload: result.data.data
      });
    } catch (error) {
      dispatch({
        type: LOADING_METADATA,
        payload: false
      });
      dispatch({
        type: ERROR_METADATA,
        payload: error
      });
    }
  };

export const deleteMetadata = id => async dispatch => {
  try {
    dispatch({
      type: LOADING_METADATA,
      payload: true
    });
    const result = await axios().delete(`/metadata/${id}`);
    dispatch({
      type: LOADING_METADATA,
      payload: false
    });
    dispatch({
      type: ERROR_METADATA,
      payload: null
    });
    dispatch({
      type: DELETE_METADATA,
      payload: result.status
    });
  } catch (error) {
    dispatch({
      type: LOADING_METADATA,
      payload: false
    });
    dispatch({
      type: DELETE_METADATA,
      payload: hasProperty(error, "response.status") ? error.response.status : 0
    });
    dispatch({
      type: ERROR_METADATA,
      payload: error
    });
  }
};

export const resetPayload = type => dispatch => {
  dispatch({
    type: type,
    payload: null
  });
};
